import PageHeader from "components/pageHeader";
import React, { useEffect, useState, useRef } from "react";
import { connect } from "react-redux";
import { useHistory, useLocation } from "react-router";
import { Button } from "components/Button";
import { DetailSection, EditImage, ImageComponent } from "./subComponents";
import TransferOwnershipModal from "./transferOwnershipModal";
import SaveConfirmation from "./saveConfirmation";
import { deleteProfilePic, saveProfileDetails } from "actions/profileNew";
import { getAddressFromPin } from "./postalApi";
import {
  otherUserProfileDetails,
  superAdminProfileDetails,
  validateEmail,
  isPhoneFormatInvalid,
} from "./userProfileData";
import { isValidPhoneNumber } from "react-phone-number-input";
import moment from "moment";
import { fetchSpecificUserProfile } from "actions/userManagementV2";
import PageDataLoader from "components/pageDataLoader";
import { setEditPrivilages } from "actions/userManagement";
import { ConsoleSqlOutlined } from "@ant-design/icons";
import { Api, Notification, attendanceCodeError } from "services";

export const designations = [
  "Director",
  "Principal",
  "Centre Head",
  "Administrator",
  "Teacher",
  "Manager",
  "Marketing",
  "Others",
];

const UserProfile = ({
  user,
  userDetails,
  saveProfileDetails,
  deleteProfilePic,
  fetchSpecificUserProfile,
  specificUserId,
  specificUserProfile,
  userRowDetails,
  fromWhere,
  othersSelectedTab,
  editPrivilage,
  setEditPrivilages,
}) => {
  console.log(
    "first condition: ",
    user?.privilage?.includes("SuperAdmin"),
    "second condition: ",
    user?.id !== specificUserId,
    "third condition: ",
    fromWhere !== "userManagementProfile",
  );
  const handleInputChange = (val, key, childkey1, childkey2) => {
    if (childkey1) {
      if (childkey2) {
        userProfileDetails[key][childkey1][childkey2] = val;
      } else {
        userProfileDetails[key][childkey1] = val;
      }
    } else {
      userProfileDetails[key] = val;
    }

    setProfileDetails({ ...userProfileDetails });
  };

  const handleFocusChange = (val, key, childkey1, childkey2) => {
    if (childkey1) {
      if (childkey2) {
        if (val !== "" && val?.length < 6) {
          userProfileDetails[key][childkey1].pincodeValid = true;
          hendlePinChange(null, childkey1);
        } else {
          userProfileDetails[key][childkey1].pincodeValid = undefined;
        }
        if (childkey2 === "pincode" && (val.length === 6 || val === "")) {
          hendlePinChange(val, childkey1);
        }
      }
    } else {
      userProfileDetails[key] = val;
    }
    setProfileDetails({ ...userProfileDetails });
  };
  const history = useHistory();
  const location = useLocation();

  // The profile APIs return addresses already parsed (an object); older data may still be a JSON string.
  const parseAddress = (addr) => {
    if (addr && typeof addr === "object") return addr;
    if (typeof addr === "string" && addr.trim() !== "") {
      try { return JSON.parse(addr) || {}; } catch (e) {}
    }
    return {};
  };

  useEffect(() => {
    let currentAddress = {},
      permanentAddress = {};

    if (location?.state?.key) {
      currentAddress = parseAddress(specificUserProfile?.basicprofile?.currentAddress);
      permanentAddress = parseAddress(specificUserProfile?.basicprofile?.permanentAddress);

      setProfileDetails({
        ...specificUserProfile,
        basicprofile: {
          ...specificUserProfile?.basicprofile,
          currentAddress: {
            pincode: currentAddress?.pincode,
            state: currentAddress?.state,
            city: currentAddress?.city,
            country: currentAddress?.country,
            h_no: currentAddress?.h_no,
            pincodeValid: currentAddress?.pincodeValid,
          },
          permanentAddress: {
            pincode: permanentAddress?.pincode,
            state: permanentAddress?.state,
            city: permanentAddress?.city,
            country: permanentAddress?.country,
            h_no: permanentAddress?.h_no,
            pincodeValid: permanentAddress?.pincodeValid,
          },
        },
      });

      if (specificUserProfile?.privilage?.includes("SuperAdmin")) {
        setPrivilages([
          {
            label: "Super Admin",
            isSelected: true,
            value: "Admin",
            disabled: true,
          },
        ]);
      } else {
        setPrivilages([
          {
            label: "Admin",
            isSelected: specificUserProfile?.privilage?.includes("Admin"),
            value: "Admin",
            disabled:
              user?.privilage?.includes("Admin") &&
              !user?.privilage?.includes("SuperAdmin"),
          },
          {
            label: "Planner",
            isSelected: specificUserProfile?.privilage?.includes("Planner"),
            value: "Planner",
            disabled: specificUserProfile?.privilage?.includes("Admin")
              ? true
              : false,
          },
          {
            label: "Fee Manager",
            isSelected: specificUserProfile?.privilage?.includes("FeeManager"),
            value: "FeeManager",
            disabled: false,
          },
          {
            label: "Leave Manager",
            isSelected:
              specificUserProfile?.privilage?.includes("LeaveManager"),
            value: "LeaveManager",
            disabled: false,
          },
          {
            label: "Institute support",
            isSelected:
              specificUserProfile?.privilage?.includes("InstituteSupport"),
            value: "InstituteSupport",
            disabled: specificUserProfile?.privilage?.includes("Admin")
              ? true
              : false,
          },
          {
            label: "Attendance marker",
            isSelected:
              specificUserProfile?.privilage?.includes("AttendanceMarker"),
            value: "AttendanceMarker",
            disabled: (specificUserProfile?.privilage?.includes("Admin") || specificUserProfile?.privilage?.includes("Planner"))
              ? true
              : false,
          },
          {
            label: "Marketing",
            isSelected: specificUserProfile?.privilage?.includes("Marketing"),
            value: "Marketing",
            disabled: false,
          },
        ]);
      }
    } else {
      currentAddress = parseAddress(userDetails?.basicprofile?.currentAddress);
      permanentAddress = parseAddress(userDetails?.basicprofile?.permanentAddress);

      setProfileDetails({
        ...userDetails,
        basicprofile: {
          ...userDetails?.basicprofile,
          currentAddress: {
            pincode: currentAddress?.pincode,
            state: currentAddress?.state,
            city: currentAddress?.city,
            country: currentAddress?.country,
            h_no: currentAddress?.h_no,
            pincodeValid: currentAddress?.pincodeValid,
          },
          permanentAddress: {
            pincode: permanentAddress?.pincode,
            state: permanentAddress?.state,
            city: permanentAddress?.city,
            country: permanentAddress?.country,
            h_no: permanentAddress?.h_no,
            pincodeValid: permanentAddress?.pincodeValid,
          },
        },
      });

      if (specificUserProfile?.privilage?.includes("SuperAdmin")) {
        setPrivilages([
          {
            label: "Super Admin",
            isSelected: true,
            value: "Admin",
            disabled: true,
          },
        ]);
      } else {
        setPrivilages([
          {
            label: "Admin",
            isSelected: userDetails?.privilage?.includes("Admin"),
            value: "Admin",
            disabled:
              user?.privilage?.includes("Admin") &&
              !user?.privilage?.includes("SuperAdmin"),
          },
          {
            label: "Planner",
            isSelected: userDetails?.privilage?.includes("Planner"),
            value: "Planner",
            disabled: false,
          },
          {
            label: "Fee Manager",
            isSelected: userDetails?.privilage?.includes("FeeManager"),
            value: "FeeManager",
            disabled: false,
          },
          {
            label: "Leave Manager",
            isSelected: userDetails?.privilage?.includes("LeaveManager"),
            value: "LeaveManager",
            disabled: false,
          },
          {
            label: "Institute support",
            isSelected: userDetails?.privilage?.includes("InstituteSupport"),
            value: "InstituteSupport",
            disabled: false,
          },
          {
            label: "Attendance marker",
            isSelected: userDetails?.privilage?.includes("AttendanceMarker"),
            value: "AttendanceMarker",
            disabled: false,
          },
          {
            label: "Marketing",
            isSelected: userDetails?.privilage?.includes("Marketing"),
            value: "Marketing",
            disabled: false,
          },
        ]);
      }
    }
  }, [userDetails, specificUserProfile, user]);

  const inputProfilePic = useRef(null);
  const [userProfileDetails, setProfileDetails] = useState({});
  const [showTransferModal, setShowTransferModal] = useState(false);
  const [isSaveHidden, setIsSaveHidden] = useState(true);
  const [initialProfileDetails, setInitialProfileDetails] = useState(null);

  useEffect(() => {
    setInitialProfileDetails(null);
  }, [userDetails, specificUserProfile]);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [editProfileModal, setEditProfileModal] = useState(false);
  const [deleteConfirmation, setdeleteConfirmation] = useState(false);
  const [pageLoader, togglePageLoader] = useState(false);

  const [privilages, setPrivilages] = useState();
  const [phoneExistsError, setPhoneExistsError] = useState(null);

  useEffect(() => {
    const emergency = userProfileDetails?.basicprofile?.emergencyPhone;
    if (!emergency) {
      setPhoneExistsError(null);
      return;
    }
    const e = String(emergency)
      .replace(/[^0-9]/g, "")
      .slice(-10);
    if (e.length < 10) {
      setPhoneExistsError(null);
      return;
    }

    // Check if same as primary
    const primary = userProfileDetails?.phone;
    if (primary) {
      const p = String(primary)
        .replace(/[^0-9]/g, "")
        .slice(-10);
      if (p === e) {
        setPhoneExistsError(null); // Let the primary same check handle it
        return;
      }
    }

    const timer = setTimeout(() => {
      Api.get("/user/users")
        .params({ search: e })
        .send((response) => {
          if (response) {
            const users = response.items || response.users || [];
            const duplicate = users.find((u) => {
              const uPhone = String(u.phone || "")
                .replace(/[^0-9]/g, "")
                .slice(-10);
              return uPhone === e && u.id !== userProfileDetails?.id;
            });
            if (duplicate) {
              setPhoneExistsError(
                "Emergency contact mobile number is already registered in the system",
              );
            } else {
              setPhoneExistsError(null);
            }
          }
        });
    }, 400);

    return () => clearTimeout(timer);
  }, [
    userProfileDetails?.basicprofile?.emergencyPhone,
    userProfileDetails?.phone,
    userProfileDetails?.id,
  ]);

  useEffect(() => {
    if (location?.state?.key == true) {
      togglePageLoader(true);
      fetchSpecificUserProfile(userRowDetails?.id, () =>
        togglePageLoader(false),
      );
    } else {
    }
  }, [location?.state?.key]);

  console.log({ userProfileDetails });

  useEffect(() => {
    if (userProfileDetails && Object.keys(userProfileDetails).length > 0) {
      if (!initialProfileDetails) {
        setInitialProfileDetails(JSON.parse(JSON.stringify(userProfileDetails)));
        setIsSaveHidden(true);
      } else {
        const tempDetails = JSON.parse(JSON.stringify(userProfileDetails));
        const tempInitial = JSON.parse(JSON.stringify(initialProfileDetails));

        delete tempDetails?.basicprofile?.permanentAddress?.sameAsCa;
        delete tempInitial?.basicprofile?.permanentAddress?.sameAsCa;

        setIsSaveHidden(
          JSON.stringify(tempInitial) === JSON.stringify(tempDetails)
        );
      }
    }
  }, [userProfileDetails, initialProfileDetails]);

  const handleSaveClick = (callback, buttonCallback) => {
    // The device UserID IS the employee code, so there is nothing to enrol as without
    // one. Caught here rather than saving and then failing on the device.
    if (userProfileDetails?.registerBiometric && !String(userProfileDetails?.attendanceEmpCode || '').trim()) {
      Notification.error('Error', 'Employee code is required to register on the biometric device');
      buttonCallback();
      return;
    }

    const codeError = attendanceCodeError(userProfileDetails?.attendanceEmpCode);
    if (codeError) {
      Notification.error('Error', codeError);
      buttonCallback();
      return;
    }

    userProfileDetails.basicprofile.currentAddress = JSON.stringify(
      userProfileDetails.basicprofile.currentAddress,
    );
    userProfileDetails.basicprofile.permanentAddress = JSON.stringify(
      userProfileDetails.basicprofile.permanentAddress,
    );
    userProfileDetails.basicprofile.dob = userProfileDetails.basicprofile.dob
      ? moment(userProfileDetails.basicprofile.dob).format("YYYY-MM-DD")
      : null;

    const params = {
      ...userProfileDetails,
      ...userProfileDetails?.basicprofile,
      id: userProfileDetails?.id,
    };
    delete params.basicprofile;

    if (params.emergencyPhone && (params.emergencyPhone.trim().toUpperCase() === "NA" || params.emergencyPhone.trim() === "")) {
      params.emergencyPhone = null;
    } else if (params.emergencyPhone) {
      params.emergencyPhone = params.emergencyPhone.replace(/\s+/g, '').replace('+', '');
    }
    
    if (params.emergencyPhone === "") {
      params.emergencyPhone = null;
    }
    
    if (params.secondaryPhone && (params.secondaryPhone.trim().toUpperCase() === "NA" || params.secondaryPhone.trim() === "")) {
      params.secondaryPhone = null;
    } else if (params.secondaryPhone) {
      params.secondaryPhone = params.secondaryPhone.replace(/\s+/g, '').replace('+', '');
    }

    if (params.secondaryPhone === "") {
      params.secondaryPhone = null;
    }

    if (params.phone) {
      params.phone = params.phone.replace(/\s+/g, '').replace('+', '');
    }

    saveProfileDetails(
      params,
      location?.state?.key == true,
      () => onSaveSuccess(callback),
      buttonCallback,
    );
  };

  console.log( "user row details",userRowDetails );

  const onSaveSuccess = (callback) => {
    callback();
    setIsSaveHidden(true);
    if (location?.state?.key == true) {
      togglePageLoader(true);
      fetchSpecificUserProfile(userRowDetails?.id, () =>
        togglePageLoader(false),
      );
    }
  };

  const handleProfileModalOk = () => {
    setEditProfileModal(false);
    inputProfilePic?.current?.click();
  };

  const hendlePinChange = (pincode, childkey) => {
    if (!pincode || pincode.trim() === "") {
      handleInputChange("", "basicprofile", childkey, "city");
      handleInputChange("", "basicprofile", childkey, "state");
      handleInputChange("", "basicprofile", childkey, "country");
      if (
        userProfileDetails?.basicprofile?.permanentAddress?.sameAsCa &&
        childkey === "currentAddress"
      ) {
        handleInputChange("", "basicprofile", "permanentAddress", "city");
        handleInputChange("", "basicprofile", "permanentAddress", "state");
        handleInputChange("", "basicprofile", "permanentAddress", "country");
      }
      return;
    }

    getAddressFromPin(pincode, (district, state, country) => {
      handleInputChange(district, "basicprofile", childkey, "city");
      handleInputChange(state, "basicprofile", childkey, "state");
      handleInputChange(country, "basicprofile", childkey, "country");
      if (
        userProfileDetails?.basicprofile?.permanentAddress?.sameAsCa &&
        childkey === "currentAddress"
      ) {
        handleInputChange(district, "basicprofile", "permanentAddress", "city");
        handleInputChange(state, "basicprofile", "permanentAddress", "state");
        handleInputChange(
          country,
          "basicprofile",
          "permanentAddress",
          "country",
        );
      }
    });
  };

  const onDeleteConfirm = (callback, successCallback) => {
    if (
      userProfileDetails?.image == "default.png" &&
      userProfileDetails?.file
    ) {
      setProfileDetails((prevDetails) => ({
        ...prevDetails,
        file: "default.png",
      }));
      successCallback();
    } else {
      deleteProfilePic(callback, location?.state?.key == true, () => {
        successCallback();
        handleInputChange("default.png", "image");
        handleInputChange(undefined, "file");
        inputProfilePic.current.value = null;
      });
    }
  };

  const handleAddrDuplicate = (val, userProfileDetails) => {
    handleInputChange(val, "basicprofile", "permanentAddress", "sameAsCa");
    if (val) {
      userProfileDetails.user.basicprofile.permanentAddress = {
        ...userProfileDetails?.basicprofile?.currentAddress,
        sameAsCa: true,
      };
    } else {
      userProfileDetails.user.basicprofile.permanentAddress = {
        h_no: "",
        city: "",
        state: "",
        country: "",
        pincode: "",
        sameAsCa: false,
      };
    }
    if (val) {
      userProfileDetails.basicprofile.permanentAddress = {
        ...userProfileDetails?.basicprofile?.currentAddress,
        sameAsCa: true,
      };
    } else {
      userProfileDetails.basicprofile.permanentAddress = {
        h_no: "",
        city: "",
        state: "",
        country: "",
        pincode: "",
        sameAsCa: false,
      };
    }
    setProfileDetails({ ...userProfileDetails });
  };

  function onCheckChange(checkedValues) {
    console.log("checkedValues", checkedValues);

    let plannerdisabled = false,
      supportdisabled = false, attendancedisabled = false;

    if (checkedValues?.includes("Admin")) {
      // checkedValues.push('Planner')
      // checkedValues.push('InstituteSupport')
      (plannerdisabled = true), (supportdisabled = true);
    }
    if(checkedValues?.includes("Planner")) {
      attendancedisabled = true;
    }

    setPrivilages([
      {
        label: "Admin",
        isSelected: checkedValues?.includes("Admin"),
        value: "Admin",
        disabled:
          user?.privilage?.includes("Admin") &&
          !user?.privilage?.includes("SuperAdmin"),
      },
      {
        label: "Planner",
        isSelected: checkedValues?.includes("Planner"),
        value: "Planner",
        disabled: plannerdisabled,
      },
      {
        label: "Fee Manager",
        isSelected: checkedValues?.includes("FeeManager"),
        value: "FeeManager",
        disabled: false,
      },
      {
        label: "Leave Manager",
        isSelected: checkedValues?.includes("LeaveManager"),
        value: "LeaveManager",
        disabled: false,
      },
      {
        label: "Institute support",
        isSelected: checkedValues?.includes("InstituteSupport"),
        value: "InstituteSupport",
        disabled: supportdisabled,
      },
      {
        label: "Attendance marker",
        isSelected: checkedValues?.includes("AttendanceMarker"),
        value: "AttendanceMarker",
        disabled: supportdisabled || attendancedisabled,
      },
      {
        label: "Marketing",
        isSelected: checkedValues?.includes("Marketing"),
        value: "Marketing",
        disabled: false,
      },
    ]);
    setProfileDetails({
      ...userProfileDetails,
      privilage: checkedValues,
    });
  }

  const primary = userProfileDetails?.phone;
  const emergency = userProfileDetails?.basicprofile?.emergencyPhone;
  let isEmergencySame = false;
  if (primary && emergency) {
    const p = String(primary)
      .replace(/[^0-9]/g, "")
      .slice(-10);
    const e = String(emergency)
      .replace(/[^0-9]/g, "")
      .slice(-10);
    isEmergencySame = p && e && p === e;
  }

  const isEmailInvalid = validateEmail(userProfileDetails?.email);

  const isPrimaryPhoneInvalid = (() => {
    const phone = userProfileDetails?.phone;
    if (!phone || phone.trim() === "" || phone === "+") {
      return false;
    }
    if (phone.startsWith("+91")) {
      return isPhoneFormatInvalid(phone) || !isValidPhoneNumber(phone);
    }
    return false;
  })();

  const isEmergencyPhoneInvalid = (() => {
    const emergency = userProfileDetails?.basicprofile?.emergencyPhone;
    if (!emergency || emergency === "NA" || emergency.trim() === "" || emergency === "+") {
      return false;
    }
    if (emergency.startsWith("+91")) {
      return isPhoneFormatInvalid(emergency) || !isValidPhoneNumber(emergency);
    }
    return false;
  })();

  const isCurrentPinInvalid = (() => {
    const pin = userProfileDetails?.basicprofile?.currentAddress?.pincode;
    const pinValid = userProfileDetails?.basicprofile?.currentAddress?.pincodeValid;
    return (pin && pin.length >= 1 && pin.length < 6) || !!pinValid;
  })();

  const isPermanentPinInvalid = (() => {
    const pin = userProfileDetails?.basicprofile?.permanentAddress?.pincode;
    const pinValid = userProfileDetails?.basicprofile?.permanentAddress?.pincodeValid;
    return (pin && pin.length >= 1 && pin.length < 6) || !!pinValid;
  })();

  const isAnyFieldInvalid =
    isEmailInvalid ||
    isPrimaryPhoneInvalid ||
    isEmergencyPhoneInvalid ||
    isCurrentPinInvalid ||
    isPermanentPinInvalid;

  return (
    <div style={{ height: "100%" }}>
      {othersSelectedTab == "Basic Profile" && location?.state?.key ? (
        <PageHeader
          title={
            location?.state?.key
              ? `${userRowDetails?.name}'s Profile`
              : "Edit Profile"
          }
          onBackPress={() => history.goBack()}
          actions={
            isSaveHidden
              ? []
              : fromWhere === "userManagementProfile" &&
                // SuperAdmin can edit anyone
                (user?.privilage?.includes("SuperAdmin") ||
                  // Admin can edit anyone except SuperAdmins and other Admins
                  (user?.privilage?.includes("Admin") &&
                    !userProfileDetails?.privilage?.includes("SuperAdmin") &&
                    !(
                      userProfileDetails?.privilage?.includes("Admin") &&
                      user?.id !== userProfileDetails?.id
                    )) ||
                  // LeaveManager can edit anyone except Admins and SuperAdmins
                  (user?.privilage?.includes("LeaveManager") &&
                    !(
                      userProfileDetails?.privilage?.includes("Admin") ||
                      userProfileDetails?.privilage?.includes("SuperAdmin")
                    )))
              ? [
                  <Button
                    type="link"
                    style={{ fontSize: 14 }}
                    disabled={
                      userProfileDetails?.name?.trim() === "" ||
                      isEmergencySame ||
                      !!phoneExistsError ||
                      isAnyFieldInvalid
                    }
                    onClick={() => setShowConfirmModal(true)}
                  >
                    SAVE
                  </Button>,
                ]
              : null
          }
          givenStyle={{ marginLeft: location?.state?.key ? -128 : 0 }}
        />
      ) : (
        <PageHeader
          title={"Edit Profile"}
          onBackPress={() => history.goBack()}
          actions={
            isSaveHidden
              ? []
              : [
                  <Button
                    type="link"
                    style={{ fontSize: 14 }}
                    disabled={
                      userProfileDetails?.name?.trim() === "" ||
                      isEmergencySame ||
                      !!phoneExistsError ||
                      isAnyFieldInvalid
                    }
                    onClick={() => setShowConfirmModal(true)}
                  >
                    SAVE
                  </Button>,
                ]
          }
        />
      )}

      <div style={{ padding: 20 }}>
        <ImageComponent
          src={userProfileDetails?.image || "default.png"}
          onChange={() => {}}
          handleEditModal={setEditProfileModal}
          ref={inputProfilePic}
          setfileInputValue={(file) => {
            handleInputChange(file, "file");
          }}
          userProfileDetails={userProfileDetails}
        />
        {user?.privilage?.includes("SuperAdmin")
          ? superAdminProfileDetails(
              userProfileDetails,
              handleInputChange,
              user,
              handleFocusChange,
              handleAddrDuplicate,
              userRowDetails,
              onCheckChange,
              privilages,
              phoneExistsError,
            )?.map((section, index) => (
              <DetailSection
                section={section}
                index={index}
                userProfileDetails={userProfileDetails}
              />
            ))
          : otherUserProfileDetails(
              userProfileDetails,
              handleInputChange,
              user,
              handleFocusChange,
              handleAddrDuplicate,
              userRowDetails,
              onCheckChange,
              privilages,
              phoneExistsError,
            ).map((section, index) => (
              <DetailSection
                section={section}
                index={index}
                userProfileDetails={userProfileDetails}
              />
            ))}
      </div>
      {user?.privilage?.includes("SuperAdmin") &&
      user?.id !== specificUserId &&
      fromWhere !== "userManagementProfile" ? (
        <div
          className="cursor-pointer"
          style={{
            paddingBottom: 60,
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Button
            style={{
              fontSize: 16,
              fontWeight: 600,
              marginTop: 20,
              backgroundColor: "#594099",
              color: "#FFFFFF",
              borderRadius: 12,
              height: 40,
              border: "none",
              marginBottom: 40,
            }}
            onClick={() => setShowTransferModal(true)}
          >
            Transfer ownership
          </Button>
        </div>
      ) : null}
      {showTransferModal && (
        <TransferOwnershipModal
          handleClose={() => setShowTransferModal(false)}
          visible={showTransferModal}
          setShowTransferModal={setShowTransferModal}
        />
      )}
      <SaveConfirmation
        saveConfirmationModal={showConfirmModal}
        onCancel={() => setShowConfirmModal(false)}
        handleOk={(callback, buttonCallback) =>
          handleSaveClick(callback, buttonCallback)
        }
      />
      <EditImage
        imageUrl={userProfileDetails?.file}
        onEditCancel={() => setEditProfileModal(false)}
        editModalVisible={editProfileModal}
        handleEditOk={handleProfileModalOk}
        deleteConfirm={() => {
          setdeleteConfirmation(true), setEditProfileModal(false);
        }}
        deleteModalVisible={deleteConfirmation}
        onDeleteCancel={() => setdeleteConfirmation(false)}
        onDeleteConfirm={(callback, successCallback) =>
          onDeleteConfirm(callback, successCallback)
        }
        setEditProfileModal={setEditProfileModal}
        setdeleteConfirmation={setdeleteConfirmation}
        fromUserProfile={true}
        setProfileDetails={setProfileDetails}
        userProfileDetails={userProfileDetails}
      />

      {location?.state?.key ? (
        <PageDataLoader visible={pageLoader} />
      ) : (
        <PageDataLoader visible={pageLoader} />
      )}
    </div>
  );
};

const mapStateToProps = (state) => {
  const { user } = state.session;
  const { userDetails, instituteDetails, othersSelectedTab } = state.profileNew;
  const { specificUserId, specificUserProfile } = state.userManagementV2;
  const { editPrivilage } = state.userManagement;

  return {
    user,
    userDetails,
    instituteDetails,
    specificUserId,
    specificUserProfile,
    othersSelectedTab,
    editPrivilage,
  };
};

const mapDispatchToProps = (dispatch) => ({
  deleteProfilePic: (callback, stopGetAccountDetails, successCallback) =>
    dispatch(
      deleteProfilePic(callback, stopGetAccountDetails, successCallback),
    ),
  saveProfileDetails: (
    params,
    stopGetAccountDetails,
    callback,
    buttonCallback,
  ) =>
    dispatch(
      saveProfileDetails(
        params,
        stopGetAccountDetails,
        callback,
        buttonCallback,
      ),
    ),
  fetchSpecificUserProfile: (id, callback) =>
    dispatch(fetchSpecificUserProfile(id, callback)),
  setEditPrivilages: (privilage) => dispatch(setEditPrivilages(privilage)),
});

export default connect(mapStateToProps, mapDispatchToProps)(UserProfile);
